import {Route} from '@angular/router';

export const error503Route: Route = {
    path: '503',
    loadChildren: () => import('./error-503.module').then(m => m.Error503Module)
};
